import React from 'react'

const ProblemId = () => {
  return (
    <header className="bg-black text-white flex justify-center  items-center md:px-10 sm:px-5 px-3 py-4   border-8    border-white rounded-3xl ">
    <div className="  items-center justify-center ">
    <div className="sm:text-2xl text-sm text-blue-600 font-medium justify-center items-center flex ">PROBLEM ID: 1607 </div>
    <div className="sm:text-xl text-sm font-medium justify-center items-center flex text-center">A smart Al based solution for traffic management on routes with heavy traffic from different directions, with real-time monitoring and adaptation of traffic light timings</div>
    </div>
  </header>
  )
}

export default ProblemId;